export default __webpack_public_path__ + "static/media/toyota.0ef52fb1.svg";